import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <>
      <section className="chapter">
        {/* <div className="chapter__headerBar" />
        <p className="chapter__title">The Invasion</p> */}

        <p className="chapter__paragraph">
          <span className="chapter__paragraph--dropcap">C</span>astle Rock, Colorado, just south of
          Denver, became something of a boom town in the 19th century when pioneers and prospectors
          headed there looking for gold and land rumored to be opening up through the Homesteading
          Act of 1862. A century and a half later, Castle Rock and Intel are looking to lure a new
          group of high-tech homesteaders to a unique suburban experiment called Miller’s Landing.
        </p>
        <p className="chapter__paragraph">
          This mixed-use community, projected to open in 2025, will be the country’s first
          SmartTown: a new development that goes beyond individual smart homes, representing a
          larger movement to craft whole communities with cutting-edge smart infrastructure. Intel
          is leading the charge on this revolutionary 65-acre project that could set the standard
          for SmartTowns to follow.
        </p>
        <p className="chapter__paragraph">
          The Miller’s Landing plan includes 960 multi-family housing units plus business,
          recreation, health, and commerce buildings. Intel’s Zana Ilhan, Global Hospitality and
          Entertainment Lead at Network and Edge Group, says that his company is in a unique
          position to deliver this interconnected community.
        </p>
        <p className="chapter__paragraph">
          “We are bringing multiple technologies into actual implementation,” he says of Intel’s
          low-latency networking interface and edge computing, audio visual capabilities, renewable
          energy technology, and future-enabling products. But it runs deeper than tech bells and
          whistles. Miller’s Landing presents a real-world use case for Intel’s biggest and
          brightest ideas to become reality with a functioning brick-and-mortar community.
        </p>
      </section>
    </>
  );
}

export default Chapter1;
